export default __webpack_public_path__ + "1b70b500.svg";